var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01758 7.99993C8.01758 8.25146 7.92154 8.50295 7.72987 8.69471L1.69533 14.7292C1.31146 15.1131 0.689081 15.1131 0.305365 14.7292C-0.0783509 14.3455 -0.0783509 13.7232 0.305365 13.3393L5.64506 7.99993L0.305551 2.66052C-0.0781649 2.27665 -0.078165 1.65446 0.305551 1.27077C0.689267 0.886713 1.31165 0.886713 1.69552 1.27077L7.73006 7.30515C7.92176 7.49701 8.01758 7.7485 8.01758 7.99993Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderRight);
export default __webpack_public_path__ + "static/media/calenderRight.0faa30d5f5e5222b1735e6f39b35adec.svg";
export { ForwardRef as ReactComponent };